import Phaser from 'phaser';

export default class Player extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y) {
    super(scene, x, y, 'player');
    
    this.scene.add.existing(this);
    this.scene.physics.add.existing(this);
    this.body.setSize(250, 300);
    this.body.setCollideWorldBounds(true);

    this.candies = [];
  }

  move({ direction = 'right', speed = 200 } = {}) {
    const factor = direction === 'right' ? 1 : -1;
    this.setFlipX(direction !== 'right');
    this.body.setVelocityX(factor * speed);
  }

  stop() {
    this.body.setVelocity(0, 0);
  }

  stickCandies() {
    this.candies = [
      this.scene.add.sprite(0, 0, 'candy2').setScale(0.2).setAngle(30),
      this.scene.add.sprite(0, 0, 'candy4').setScale(0.2).setAngle(-40),
    ];
  }

  preUpdate() {
    this.candies.forEach((candy, index) => {
      if (index === 0) {
        candy.setPosition(this.x + 35, this.y - 55);
      }
      if (index === 1) {
        candy.setPosition(this.x - 40, this.y - 100);
      }
    });
  }
}

export function preload(model) {
  this.load.image(`player`, `characters/${model}.png`);
}
